// extracted by mini-css-extract-plugin
export default {"fabricadosL1":"FabricadosL1_fabricadosL1__bIcae","smallPiegraph":"FabricadosL1_smallPiegraph__4Fa09"};